if (!customElements.get("gallery-with-scale")) {
  customElements.define(
    "gallery-with-scale",
    class LocationSelectorWrapper extends HTMLElement {
      #slides;
      #prevButton;
      #nextButton;
      #autoSwitchTimer;
      #throttleTimer = null;

      constructor() {
        super();
        this.#slides = Array.from(this.querySelectorAll(".gallery-with-scale__item"));
        this.#prevButton = this.querySelector(".button-prev");
        this.#nextButton = this.querySelector(".button-next");
      }

      connectedCallback() {
        this.setContainerHeight();
        // this.moveEndSlideToFirst();
        this.createOperationButtons();
        this.bindEvents();
      }

      disconnectedCallback() {
        this.#clearAutoSwitch();
      }

      bindEvents() {
        this.bindTouchEvents();
        this.bindSwitchEvents();
        // this.bindHoverEvents();
        // this.autoSwitch();
      }

      moveEndSlideToFirst() {
        const parent = this.#slides[0].parentNode;
        const moved = this.#slides.pop();
        parent.insertBefore(moved, parent.firstChild);
        this.#slides.unshift(moved);
      }

      /** 根据图片渲染的高度设置容器高度 */
      setContainerHeight() {
        if (!this.#slides?.length) return;
        const height = this.#slides[0]?.querySelector("img")?.clientHeight;
        if (!height) return;
        this.style.height = `${height + 30}px`;
      }

      /** 创建切换按钮 */
      createOperationButtons() {
        const prevButton = document.createElement("button");
        prevButton.classList.add("circle-button", "circle-button--xs", "circle-button--fill");
        prevButton.setAttribute("is", "prev-button");
        prevButton.innerHTML = '<span class="animated-arrow animated-arrow--reverse"></span>';
        this.appendChild(prevButton);
        this.#prevButton = prevButton;
        const nextButton = document.createElement("button");
        nextButton.classList.add("circle-button", "circle-button--xs", "circle-button--fill");
        nextButton.setAttribute("is", "next-button");
        nextButton.innerHTML = '<span class="animated-arrow"></span>';
        this.appendChild(nextButton);
        this.#nextButton = nextButton;
      }

      /** 自动轮播 */
      autoSwitch(interval = 3000) {
        this.#clearAutoSwitch();
        this.#autoSwitchTimer = setInterval(() => {
          console.log("auto", 1);
          this.switchWithNumber(1);
        }, interval);
      }

      /** 绑定切换按钮事件 */
      bindSwitchEvents() {
        if (window.innerWidth < 1000) {
          this.#prevButton?.addEventListener("touchend", () => this.switchWithNumber(1));
          this.#nextButton?.addEventListener("touchend", () => this.switchWithNumber(-1));
        } else {
          this.#prevButton?.addEventListener("click", () => this.switchWithNumber(1));
          this.#nextButton?.addEventListener("click", () => this.switchWithNumber(-1));
        }
      }

      /** 新增悬停事件控制 */
      bindHoverEvents() {
        this.addEventListener("mouseenter", () => this.#clearAutoSwitch());
        this.addEventListener("mouseleave", () => this.autoSwitch());
      }

      /** 绑定触摸事件 */
      bindTouchEvents() {
        let touchStartX = 0;
        let touchEndX = 0;

        this.addEventListener("touchstart", (e) => {
          touchStartX = e.changedTouches[0].clientX;
        });

        this.addEventListener("touchmove", (e) => {
          touchEndX = e.changedTouches[0].clientX;
          const diff = touchEndX - touchStartX;
          if (Math.abs(diff) > 50) {
            e.preventDefault();
          }
        });

        this.addEventListener("touchend", (e) => {
          touchEndX = e.changedTouches[0].clientX;
          const diff = touchEndX - touchStartX;
          if (Math.abs(diff) > 50) {
            console.log("end", diff > 0 ? -1 : 1);
            this.switchWithNumber(diff > 0 ? -1 : 1);
          }
        });
      }

      /** 核心移动方法 */
      switchWithNumber(number) {
        if (number === 0 || this.#slides.length <= 1 || this.#throttleTimer) return;

        const moveCount = Math.abs(number);
        const isLeft = number < 0;
        const parent = this.#slides[0].parentNode;

        for (let i = 0; i < moveCount; i++) {
          if (isLeft) {
            // 将最后一个元素移到开头
            const moved = this.#slides.pop();
            parent.insertBefore(moved, parent.firstChild);
            this.#slides.unshift(moved);
          } else {
            // 将第一个元素移到末尾
            const moved = this.#slides.shift();
            parent.appendChild(moved);
            this.#slides.push(moved);
          }
        }
        this.#throttleTimer = setTimeout(() => {
          this.#throttleTimer = null;
        }, 500);
      }

      #clearAutoSwitch() {
        if (this.#autoSwitchTimer) {
          clearInterval(this.#autoSwitchTimer);
          this.#autoSwitchTimer = null;
        }
      }
    }
  );
}
